import React, { useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { isEmpty } from 'lodash-es';
import {
  DoconModal,
  DoconModalContent,
  FlexBox,
  Heading3,
  Icons,
  TertiaryButton,
} from '@docon/docon-ui-library';
import { borderColor, colors } from 'utilities/colorConfig';
import { formatMobileNumber } from 'utils';

const Modal = styled(DoconModal)`
  max-height: 80vh;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  transition: all 1s ease;
  
  ${DoconModalContent} {
    max-height: initial;
    padding: 0;
  }
  
  ${({ $isMount }) => isMobileOnly && css`
    border-radius: 0;
    margin-top: auto;
    animation: none;
    --contentTop: ${$isMount ? 0 : '100vh'};
  `}
`;

const Row = styled(FlexBox)`
  padding: 8px 20px;
  flex: 100%;
  gap: 0 16px;
  align-items: center;
  color: ${colors.primaryBlue};
  cursor: pointer;
  
  & + & {
    border-top: 1px solid ${borderColor};
  }
`;

function OtherNumbers({
  isOpen,
  clinics = [],
  clinic = {},
  onClose,
  ...props
}: any) {

  const [isMount, setIsMount] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsMount(true);
    }, 5);
  }, []);

  function handleClick(event: any) {
    const number = event?.currentTarget?.id;
    window.location.href = `tel: ${number}`;
  }

  function renderPhoneLists(clinic: any) {
    if (isEmpty(clinic)) return null;

    return (
      [clinic.number, ...(clinic.otherNumbers || [])].map((number: number) => (
        <Row key={number} id={number} onClick={handleClick}>
          <Icons.PhoneIcon width={18} />
          <TertiaryButton
            m='0 !important'
            p='0 !important'
            size={'small'}
            title={formatMobileNumber(number)}
          />
        </Row>
      ))
    );
  }
  return (
    <Modal
      hideFooter
      centered={!isMobileOnly}
      isOpen={isOpen}
      $isMount={isMount}
      onClose={onClose}
      {...props}
    >
      {renderPhoneLists(clinic)}

      {
        clinics.map((clinic) => (
          <Row key={clinic.clinicID}>
            <Heading3 fontWeight={500} title={clinic.name} />
            {renderPhoneLists(clinic)}
          </Row>
        ))
      }
    </Modal>
  );
}

export default OtherNumbers;